import { Array, Effect, RequestResolver, pipe } from 'effect';
import { Url } from '../../../api';
import { RequestError } from '../../../requests/requestError';
import { decodeModularTemplate, decodeModularTemplateListResponse, } from '../../../schemas/modularTemplate';
export const GetModularTemplateResolver = (http, gavelUrl) => RequestResolver.fromEffect((request) => http
    .get(Url.join(gavelUrl, `/api/v1/${request.tenant}/modular-templates/${request.id}`))
    .pipe(Effect.mapError(_x => RequestError.FetchError), Effect.andThen(r => decodeModularTemplate(r.body))));
export const GetModularOptionsResolver = (getModularTemplateById, productService) => RequestResolver.fromEffect((request) => Effect.gen(function* (_) {
    const template = yield* _(getModularTemplateById(request.tenant, request.id));
    const moduleOptions = yield* _(pipe(Object.entries(template.modules), Array.map(([moduleType, moduleInfos]) => pipe(Array.map(moduleInfos, moduleInfo => pipe(productService.getByGroupingCode(request.tenant, moduleInfo.groupingCode), Effect.orElseFail(() => RequestError.FetchError), // TODO: Errors.
    Effect.map((optionProducts) => Array.map(optionProducts, (product) => {
        const numberOfSeats = product.properties['Number of Seats'];
        const seatCount = typeof numberOfSeats === 'number'
            ? numberOfSeats
            : 1;
        const finishName = 'finish' in product.properties &&
            typeof product.properties.finish === 'object' &&
            product.properties.finish !== null &&
            'name' in product.properties.finish
            ? product.properties.finish.name
            : undefined;
        const fabric = typeof finishName === 'string'
            ? finishName
            : undefined;
        const feet = typeof product.properties['feet'] === 'string'
            ? product.properties['feet']
            : undefined;
        const cushionStyle = typeof product.properties['cushionstyle'] ===
            'string'
            ? product.properties['cushionstyle']
            : undefined;
        const productDims = Object.values(product.properties['dimension'] ?? {}).reduce((w, dimension) => {
            const dimName = dimension['label'] === 'Width'
                ? 'width'
                : dimension['label'] === 'Height'
                    ? 'height'
                    : dimension['label'] === 'Depth'
                        ? 'depth'
                        : null;
            if (dimName === null)
                return w;
            if (!dimension['value'] ||
                typeof dimension['value'] !== 'number')
                return w;
            let value;
            if (dimension['unit'] === 'mm') {
                value = dimension['value'] / 1000;
            }
            if (value === undefined)
                return w;
            return { ...w, [dimName]: value };
        }, {});
        return {
            particleId: `${product.canonicalId}-${product.productType}`,
            seatCount,
            properties: {
                GroupingCode: moduleInfo.groupingCode,
                Product: product.canonicalId,
                ...(fabric !== undefined ? { fabric } : {}),
                ...(feet !== undefined ? { feet } : {}),
                ...(cushionStyle !== undefined
                    ? { cushion: cushionStyle }
                    : {}),
            },
            bounds: {
                ...moduleInfo.bounds,
                rightHanded: moduleInfo.bounds.rightHanded ?? false,
            },
            productDims,
        };
    })))), Effect.all, Effect.map((moduleOptions) => [
        moduleType,
        moduleOptions.flat(),
    ]))), Effect.all, Effect.map(Object.fromEntries)));
    return { ...template, modules: moduleOptions };
}));
export const ListModularTemplatesResolver = (http, gavelUrl) => RequestResolver.fromEffect((request) => http.get(Url.join(gavelUrl, `/api/v1/${request.tenant}/modular-templates`)).pipe(Effect.mapError(_x => RequestError.FetchError), Effect.andThen(r => decodeModularTemplateListResponse(r.body)), Effect.map(l => l.modularTemplates)));
